import { Link } from 'react-router-dom';
import '../styles/about.css';

const About = () => {
  // Estilos inline para asegurar que las secciones ocupen todo el ancho disponible
  const sectionStyle = {
    width: '100%',
    margin: 0,
    padding: '60px 0',
    boxSizing: 'border-box',
  };

  const containerStyle = {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    boxSizing: 'border-box',
  };

  return (
    <>
      {/* Page Header Section */}
      <section
        className="page-header"
        style={{
          ...sectionStyle,
          backgroundColor: 'var(--primary-light)',
          textAlign: 'center',
          padding: '40px 0',
        }}
      >
        <div className="container" style={containerStyle}>
          <h1 style={{ fontSize: '2.5rem', color: 'var(--primary-dark)', marginBottom: '10px' }}>
            Sobre Nosotros
          </h1>
          <p style={{ fontSize: '1.2rem', color: 'var(--text-primary)' }}>
            Conoce más sobre Liga ProKids y nuestra misión
          </p>
        </div>
      </section>

      {/* About Content Section */}
      <section
        className="about-section"
        style={{ ...sectionStyle, backgroundColor: 'var(--background-light)' }}
      >
        <div className="container" style={containerStyle}>
          <div
            className="about-content"
            style={{ display: 'flex', gap: '40px', marginBottom: '60px', flexWrap: 'wrap' }}
          >
            <div className="about-text" style={{ flex: '1', minWidth: '300px' }}>
              <h2 style={{ fontSize: '2rem', color: 'var(--primary-dark)', marginBottom: '20px' }}>
                Nuestra Historia
              </h2>
              <p style={{ marginBottom: '20px', fontSize: '1.1rem', lineHeight: '1.6' }}>
                Liga ProKids nació en 2024 con una misión clara: crear un entorno donde los niños y
                niñas puedan disfrutar del fútbol mientras desarrollan habilidades deportivas y
                valores personales.
              </p>
              <p style={{ marginBottom: '30px', fontSize: '1.1rem', lineHeight: '1.6' }}>
                Lo que comenzó como una pequeña iniciativa local se ha convertido en una comunidad
                vibrante con cientos de jóvenes futbolistas que participan regularmente en nuestros
                partidos y actividades.
              </p>

              <h2 style={{ fontSize: '2rem', color: 'var(--primary-dark)', marginBottom: '20px' }}>
                Nuestra Misión
              </h2>
              <p style={{ marginBottom: '20px', fontSize: '1.1rem', lineHeight: '1.6' }}>
                En Liga ProKids creemos que el deporte es una herramienta poderosa para el
                desarrollo integral de los niños. Nuestra misión es:
              </p>
              <ul style={{ marginLeft: '20px', marginBottom: '30px' }}>
                <li style={{ marginBottom: '10px', fontSize: '1.1rem' }}>
                  Fomentar la práctica deportiva regular en un ambiente divertido y seguro
                </li>
                <li style={{ marginBottom: '10px', fontSize: '1.1rem' }}>
                  Promover valores como el trabajo en equipo, el respeto y la deportividad
                </li>
                <li style={{ marginBottom: '10px', fontSize: '1.1rem' }}>
                  Desarrollar habilidades técnicas y tácticas adaptadas a cada edad
                </li>
                <li style={{ marginBottom: '10px', fontSize: '1.1rem' }}>
                  Crear una comunidad inclusiva donde todos los niños tengan la oportunidad de
                  participar
                </li>
              </ul>
            </div>
            <div
              className="about-image"
              style={{
                flex: '1',
                minWidth: '300px',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 4px 8px var(--shadow-color)',
              }}
            >
              <img
                src="/img/1x/foto_vertical_1.jpeg"
                srcSet="/img/1x/foto_vertical_1.jpeg 1x, /img/4x/foto_vertical_1.jpeg 4x"
                alt="Liga ProKids - Sobre nosotros"
                style={{ width: '100%', height: 'auto', display: 'block' }}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div
                style={{
                  display: 'none',
                  padding: '40px',
                  backgroundColor: '#f5f5f5',
                  color: '#666',
                  fontSize: '1.1rem',
                  textAlign: 'center',
                }}
              >
                📸 Imagen próximamente disponible
              </div>
            </div>
          </div>

          <div className="about-features" style={{ marginBottom: '60px' }}>
            <h2
              style={{
                fontSize: '2rem',
                color: 'var(--primary-dark)',
                marginBottom: '30px',
                textAlign: 'center',
              }}
            >
              ¿Qué nos hace diferentes?
            </h2>
            <div
              className="features-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '30px',
              }}
            >
              <div
                className="feature-card"
                style={{
                  backgroundColor: 'var(--background-light)',
                  borderRadius: '8px',
                  padding: '30px',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px var(--shadow-color)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
              >
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: 'var(--primary-light)',
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                  }}
                >
                  <span
                    className="material-icons"
                    style={{ fontSize: '36px', color: 'var(--primary-color)' }}
                  >
                    sports_soccer
                  </span>
                </div>
                <h3
                  style={{ fontSize: '1.5rem', marginBottom: '15px', color: 'var(--primary-dark)' }}
                >
                  Jornadas Adaptadas
                </h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
                  Organizamos jornadas adaptadas a cada categoría de edad, con reglas y campos
                  adecuados para maximizar la diversión y el aprendizaje.
                </p>
              </div>
              <div
                className="feature-card"
                style={{
                  backgroundColor: 'var(--background-light)',
                  borderRadius: '8px',
                  padding: '30px',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px var(--shadow-color)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
              >
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: 'var(--primary-light)',
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                  }}
                >
                  <span
                    className="material-icons"
                    style={{ fontSize: '36px', color: 'var(--primary-color)' }}
                  >
                    emoji_events
                  </span>
                </div>
                <h3
                  style={{ fontSize: '1.5rem', marginBottom: '15px', color: 'var(--primary-dark)' }}
                >
                  Sistema de Logros
                </h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
                  Nuestro sistema único de logros y sistema Propoints motiva a los jugadores a mejorar y
                  reconoce no solo las habilidades técnicas sino también valores como el
                  compañerismo.
                </p>
              </div>
              <div
                className="feature-card"
                style={{
                  backgroundColor: 'var(--background-light)',
                  borderRadius: '8px',
                  padding: '30px',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px var(--shadow-color)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
              >
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: 'var(--primary-light)',
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                  }}
                >
                  <span
                    className="material-icons"
                    style={{ fontSize: '36px', color: 'var(--primary-color)' }}
                  >
                    phone_android
                  </span>
                </div>
                <h3
                  style={{ fontSize: '1.5rem', marginBottom: '15px', color: 'var(--primary-dark)' }}
                >
                  Plataforma Digital
                </h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
                  A través de nuestra app y web, los jugadores y padres pueden gestionar
                  inscripciones, seguir el progreso y estar al día de todas las actividades.
                </p>
              </div>
              <div
                className="feature-card"
                style={{
                  backgroundColor: 'var(--background-light)',
                  borderRadius: '8px',
                  padding: '30px',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px var(--shadow-color)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                }}
              >
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: 'var(--primary-light)',
                    width: '70px',
                    height: '70px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                  }}
                >
                  <span
                    className="material-icons"
                    style={{ fontSize: '36px', color: 'var(--primary-color)' }}
                  >
                    diversity_3
                  </span>
                </div>
                <h3
                  style={{ fontSize: '1.5rem', marginBottom: '15px', color: 'var(--primary-dark)' }}
                >
                  Inclusividad
                </h3>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
                  Creemos que el fútbol es para todos. Ofrecemos categorías mixtas y trabajamos para
                  que todos los niños, independientemente de su nivel, puedan participar.
                </p>
              </div>
            </div>
          </div>

          <div
            className="about-testimonials"
            style={{
              backgroundColor: 'transparent',
              padding: '40px',
              borderRadius: '8px',
              marginBottom: '60px',
              color: 'var(--text-primary)',
            }}
          >
            <h2
              style={{
                fontSize: '2rem',
                color: 'var(--primary-dark)',
                marginBottom: '30px',
                textAlign: 'center',
              }}
            >
              Lo que dicen de nosotros
            </h2>
            <div
              className="testimonials-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '30px',
              }}
            >
              <div
                className="testimonial"
                style={{
                  backgroundColor: 'var(--background-light)',
                  borderRadius: '8px',
                  padding: '25px',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px var(--shadow-color)',
                  border: '1px solid var(--border-color)',
                }}
              >
                <img
                  src="/img/1x/testimonial-1.png"
                  alt="María G."
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    marginBottom: '20px',
                    objectFit: 'cover',
                    border: '3px solid var(--primary-color)',
                  }}
                />
                <p
                  style={{
                    fontSize: '1.1rem',
                    fontStyle: 'italic',
                    marginBottom: '20px',
                    lineHeight: '1.6',
                    color: 'var(--text-primary)',
                  }}
                >
                  Mi hijo ha mejorado muchísimo desde que se unió a Liga ProKids. Le encanta el sistema de logros y está siempre motivado para el siguiente partido.
                </p>
                <h4
                  style={{
                    fontSize: '1.2rem',
                    fontWeight: '600',
                    marginBottom: '5px',
                    color: 'var(--primary-dark)',
                  }}
                >
                  María G.
                </h4>
                <p
                  style={{
                    fontSize: '0.9rem',
                    color: 'var(--text-secondary)',
                    fontWeight: '400',
                  }}
                >
                  Madre de Alejandro, 9 años
                </p>
              </div>

              <div
                className="testimonial"
                style={{
                  backgroundColor: 'var(--background-light)',
                  borderRadius: '8px',
                  padding: '25px',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px var(--shadow-color)',
                  border: '1px solid var(--border-color)',
                }}
              >
                <img
                  src="/img/1x/testimonial-2.png"
                  alt="Carlos R."
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    marginBottom: '20px',
                    objectFit: 'cover',
                    border: '3px solid var(--primary-color)',
                  }}
                />
                <p
                  style={{
                    fontSize: '1.1rem',
                    fontStyle: 'italic',
                    marginBottom: '20px',
                    lineHeight: '1.6',
                    color: 'var(--text-primary)',
                  }}
                >
                                    La organización es excelente y los entrenadores son muy profesionales. Mi hija disfruta cada partido y ha hecho muchos amigos.
                </p>
                <h4
                  style={{
                    fontSize: '1.2rem',
                    fontWeight: '600',
                    marginBottom: '5px',
                    color: 'var(--primary-dark)',
                  }}
                >
                  Carlos R.
                </h4>
                <p
                  style={{
                    fontSize: '0.9rem',
                    color: 'var(--text-secondary)',
                    fontWeight: '400',
                  }}
                >
                  Padre de Laura, 8 años
                </p>
              </div>

              <div
                className="testimonial"
                style={{
                  backgroundColor: 'var(--background-light)',
                  borderRadius: '8px',
                  padding: '25px',
                  textAlign: 'center',
                  boxShadow: '0 2px 4px var(--shadow-color)',
                  border: '1px solid var(--border-color)',
                }}
              >
                <img
                  src="/img/1x/testimonial-3.png"
                  alt="Ana M."
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    marginBottom: '20px',
                    objectFit: 'cover',
                    border: '3px solid var(--primary-color)',
                  }}
                />
                <p
                  style={{
                    fontSize: '1.1rem',
                    fontStyle: 'italic',
                    marginBottom: '20px',
                    lineHeight: '1.6',
                    color: 'var(--text-primary)',
                  }}
                >
                                    Liga ProKids ha sido una experiencia increíble para toda la familia. Los niños aprenden valores importantes mientras se divierten.
                </p>
                <h4
                  style={{
                    fontSize: '1.2rem',
                    fontWeight: '600',
                    marginBottom: '5px',
                    color: 'var(--primary-dark)',
                  }}
                >
                  Ana M.
                </h4>
                <p
                  style={{
                    fontSize: '0.9rem',
                    color: 'var(--text-secondary)',
                    fontWeight: '400',
                  }}
                >
                  Madre de Daniel, 10 años
                </p>
              </div>
            </div>
          </div>

          <div
            className="about-cta"
            style={{
              backgroundColor: 'var(--primary-color)',
              color: 'var(--text-light)',
              textAlign: 'center',
              padding: '40px',
              borderRadius: '8px',
            }}
          >
            <h2 style={{ fontSize: '2rem', marginBottom: '15px' }}>
              ¿Quieres formar parte de Liga ProKids?
            </h2>
            <p style={{ fontSize: '1.1rem', marginBottom: '30px', opacity: '0.9' }}>
              Únete a nuestra comunidad y descubre una nueva forma de disfrutar del fútbol.
            </p>
            <div
              className="cta-buttons"
              style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}
            >
              <Link
                to="/register"
                className="btn"
                style={{
                  display: 'inline-block',
                  padding: '15px 30px',
                  fontSize: '1.1rem',
                  fontWeight: '500',
                  borderRadius: '30px',
                  backgroundColor: 'white',
                  color: 'var(--primary-color)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  textDecoration: 'none',
                }}
              >
                Regístrate Ahora
              </Link>
              <Link
                to="/contact"
                className="btn"
                style={{
                  display: 'inline-block',
                  padding: '15px 30px',
                  fontSize: '1.1rem',
                  fontWeight: '500',
                  borderRadius: '30px',
                  backgroundColor: 'var(--secondary-color)',
                  color: 'white',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  textDecoration: 'none',
                }}
              >
                Contáctanos
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
